import { Inject, Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { forkJoin, Observable, ReplaySubject } from 'rxjs';
import { ShareLink } from '../models/sharelink';
import { ShareSettings } from '../models/sharesettin';
import { FileFolderItem } from '../folder/folder.component';
import { GlobalConstants } from '../app.component';
import * as microsoftTeams from "@microsoft/teams-js";
import { Router } from '@angular/router'; // import router from angular router
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})

export class APIService {
 
  //https://qa-msteamsintegration-webapp.azurewebsites.net/api
  //  https://msteamswebappangular.azurewebsites.net/api
  //'https://qa-msteamsintegration-webapp.azurewebsites.net/api
  //https://msteamswebappangular.azurewebsites.net/api
  //https://eastus2-highq-lab-qa-mstint-azapp.azurewebsites.net/api
  //https://local-sub-dev-mstint-azapp.azurewebsites.net/api
  //https://local-sub-dev-mstint-azapp.azurewebsites.net/accessdenied

  APIBASEURL: string;
  SITES: string = 'sites'
  ADDFILE: string = 'addfile'
  ADDFILECHUNK: string = 'chunkupload'
  FAVOURITES: string = 'favourite'
  FOLDER_INFO: string = 'folderinfo'
  UPLOAD_PROGRESS: string = 'documentstatus'
  CHUNKSETTINGS: string = 'chunksettings'
  BASICDETAILS: string = 'basicdetails'
  FILES: string = 'files'
  DUPLICATES: string = 'duplicates'
  ordertype: string;
  orderby: string;
  isUnitTest: boolean=true;
  
  constructor(private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private route: Router,
  ) {
      this.APIBASEURL = baseUrl + 'api';
  }

  setUnitcase(isUnitTest: boolean,strTid:string) {
    this.isUnitTest=isUnitTest;
    GlobalConstants.Tid=strTid;
    GlobalConstants.IsTeamsIni = true;     
  }
  
  getSitesFirstCall(siteName: string, offset: number, limit: number, activeSort: string) {
    let result1 = this.http.get<Object>(`${this.APIBASEURL}/${this.SITES}?name=${siteName}`);
    this.setSiteSort(activeSort);
    let result2 = this.http.get<Object>(`${this.APIBASEURL}/${this.SITES}?filterby=all&&offset=${offset}&limit=${limit}&ordertype=${this.ordertype}&orderby=${this.orderby}`)
    return this.getSiteData(result1, result2)
  }

  getSiteData(result1, result2): Observable<any> {
    return forkJoin([result1, result2]);
  }

  getSite(siteids: any) {
    return this.http.get<Object>(encodeURI(`${this.APIBASEURL}/${this.SITES}?siteids=${siteids}`))
  }

  getSiteByName(siteName: any) {
    return this.http.get<Object>(`${this.APIBASEURL}/${this.SITES}?name=${siteName}`)
  }

  getSites(offset: number, limit: number, activeSort: string) {
    this.setSiteSort(activeSort);
    return this.http.get<Object>(`${this.APIBASEURL}/${this.SITES}?filterby=all&&offset=${offset}&limit=${limit}&ordertype=${this.ordertype}&orderby=${this.orderby}`)
  }

  logoutUser() {
    return this.http.post(`${this.APIBASEURL}/unauthorizeuser`, "")
  }

  getUploadProgress(progresskey: string, siteId: number) {
    const formData = new FormData();
    formData.append('siteid', siteId + '');
    formData.append('key', progresskey);
    return this.http.post(`${this.APIBASEURL}/${this.UPLOAD_PROGRESS}`, { siteid: siteId, localkey: progresskey })
  }

  uploadFile(parentFolderId: number, file: File, siteId: number, fname: string, overrideDuplicate: boolean) {
    const formData = new FormData();
    formData.append('siteid', siteId + '');
    formData.append('parentfolderid', parentFolderId + '');
    formData.append('overrideduplicate', overrideDuplicate + '');
    formData.append('formfile', file, 'AAA.txt')
    formData.append('filename', 'AAA.txt')
    formData.append('filesize', file.size + '')
    const headers = { 'fname': encodeURI(fname) }
    return this.http.post<any>(`${this.APIBASEURL}/${this.ADDFILE}`, formData, { headers })
  }

  uploadChunk(parentFolderId: number, siteId: number, file: Blob, fname: string, overrideDuplicate: boolean, contentRange: string, routeId: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('siteid', siteId + '');
    formData.append('parentfolderid', parentFolderId + '');
    formData.append('overrideduplicate', overrideDuplicate + '');
    formData.append('formfile', file, 'AAA.txt')
    formData.append('filename', 'AAA.txt');
    formData.append('filesize', file.size + '');
    const headers = { fname: encodeURI(fname), ContentRange: contentRange, RouteId: routeId };
    return this.http.post<any>(`${this.APIBASEURL}/${this.ADDFILE}`, formData, { headers });
  }

  
  getFileDuplicates(fileName:String,parentFolderId: number){
    return this.http.get<Object>(`${this.APIBASEURL}/${this.FILES}/${this.DUPLICATES}/${fileName}?parentfolderid=${parentFolderId}`)
  }
  getChunkuploadConfigurations(){
    return this.http.get<Object>(`${this.APIBASEURL}/${this.CHUNKSETTINGS}`)
  }

  getInstanceInfo(){
    return this.http.get<Object>(`${this.APIBASEURL}/${this.BASICDETAILS}`)
  }

  
  public getFolderInfo(siteFolderId: number) {
    return this.http.get<Object>(encodeURI(`${this.APIBASEURL}/${this.FOLDER_INFO}/${siteFolderId}`))
  }

  getFavourites(contenttype: string, offset: number, limit: number) {
    return this.http.get<Object>(`${this.APIBASEURL}/${this.FAVOURITES}?contenttype=${contenttype}&offset=${offset}&limit=${limit}`)
  }

  getRecentActivities(lastactivityid: number, limit: number) {
    return this.http.get<Object>(`${this.APIBASEURL}/recentactivities?lastactivityid=${lastactivityid}&limit=${limit}`)
  }

  getFileInfo(fileId: number) {
    return this.http.get<FileFolderItem>(`${this.APIBASEURL}/fileinfo/${fileId}`)
  }

  getFolders(folderId: number, offset: number, limit: number, activeSort: string) {
    this.setSort(activeSort);
    return this.http.get<Object>(`${this.APIBASEURL}/folders/${folderId}?offset=${offset}&limit=${limit}&ordertype=${this.ordertype}&orderby=${this.orderby}`)
  }

  getFiles(folderId: number, offset: number, limit: number, activeSort: string) {
    this.setSort(activeSort);
    return this.http.get<Object>(`${this.APIBASEURL}/files/${folderId}?offset=${offset}&limit=${limit}&ordertype=${this.ordertype}&orderby=${this.orderby}`)
  }

  authenticateUserCall() {
    return this.http.get<Object>(`${this.APIBASEURL}/validateuser`)
  }

  getInstance(url: string) {
    return this.http.get<Object>(`${this.APIBASEURL}/instance/${url}`)
  }

  getTokens(code: string) {
    return this.http.get<Object>(`${this.APIBASEURL}/oauth/${code}`)
  }

  getAccountDetails() {
    return this.http.get<Object>(`${this.APIBASEURL}/accountdetails`)
  }

  getDRMSettings(islocal: boolean) {
    return this.http.get<ShareSettings>(`${this.APIBASEURL}/sharesettings/${islocal}`)
  }

  saveShareSettings(saveSharesettings: ShareSettings) {
    return this.http.post(`${this.APIBASEURL}/sharesettings`, saveSharesettings)
  }

  getSupportedFileTypes(filetype: string) {
    return this.http.get<Object>(encodeURI(`${this.APIBASEURL}/filetypedetails/${filetype}`))
  }

  shareLink(sharelink: ShareLink) {
    return this.http.post(`${this.APIBASEURL}/sharelink`, sharelink)
  }

  refresh(): Observable<string> {
    const refreshObservable = this.http.get(`${this.APIBASEURL}/oauth/refresh`)

    const refreshSubject = new ReplaySubject<string>(1);
    refreshSubject.subscribe((r: string) => {
      GlobalConstants.Jwi = r['Value']
    });

    refreshObservable.subscribe(refreshSubject);
    return refreshSubject;
  }

  setSiteSort(activeSort: string) {
    if (activeSort === 'nameza') {
      this.ordertype = 'sitename'
      this.orderby = 'desc'
    } else {
      this.ordertype = 'sitename'
      this.orderby = 'asc'
    }
  }
  setSort(activeSort: string) {
    if (activeSort === 'dateoldnew') {
      this.ordertype = 'lastModified'
      this.orderby = 'asc'
    } else if (activeSort === 'datenewold') {
      this.ordertype = 'lastModified'
      this.orderby = 'desc'
    } else if (activeSort === 'nameza') {
      this.ordertype = 'name'
      this.orderby = 'desc'
    } else {
      this.ordertype = 'name'
      this.orderby = 'asc'
    }
  }

  GetMsTeams() {
    if (GlobalConstants.Tid.length < 1) {
      GlobalConstants.IsTeamsIni = false;
      this.fatchTeamsId();
    }

    setTimeout(() => {
      if (!GlobalConstants.IsTeamsIni) {
        this.route.navigate(['/accessdenied']);
      }
    }, 7000);
  }

  public fatchTeamsId() {
    microsoftTeams.initialize(() => {
      GlobalConstants.IsTeamsIni = true;
      microsoftTeams.getContext(function (context) {
        GlobalConstants.Tid = context.userObjectId;
        GlobalConstants.theme = context.theme
        GlobalConstants.Name = context.userPrincipalName;
      });
    });
  }

  public ValidateMsTeamContextAndFatchTeamsId(sharedService: SharedService) {
    if (!GlobalConstants.IsTeamsIni) {
      var mode = this.GetMode();
      if (mode === null || mode === undefined || mode === '') {
        this.RedirectPageBasedOnMode(sharedService, '0');
      }
      else
        GlobalConstants.IsTeamsIni = true;
    }

    this.GetMsTeams();
  }

  public submitTask(Value) {
    if (Value != undefined && Value != null)
      microsoftTeams.tasks.submitTask(Value);
    else
      microsoftTeams.tasks.submitTask();
  }

  public RedirectPageBasedOnMode(sharedService: SharedService, mode: string) {
    sharedService.settingsScreen(true) //NavMenu not visible
    if (mode == '1')
      this.route.navigate(['/settings']);
    else if (mode == '2')
      this.route.navigate(['/upload']);
    else if (mode == '3') {
      sharedService.settingsScreen(false) //visible
      this.route.navigate(['/sites']);
    }
    else
      this.route.navigate(['/accessdenied']);
  }

  public GetMode() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('mode');
  }

  public setTheme() {
    if (GlobalConstants.theme == 'dark')
      this.setDarkTheme();
    else if (GlobalConstants.theme == 'contrast')
      this.setHighlightedTheme();
    else
      this.setLightTheme();
  }

  setLightTheme() {
    document.body.className = '';
    document.body.className = 'defaulttheme';
    // var r: HTMLElement = document.querySelector(':root');
    // r.style.setProperty('--themebg', 'white');
    // r.style.setProperty('--themebg2', 'white');
    // r.style.setProperty('--black', '#000000');
    // r.style.setProperty('--gray', 'gray');
    // r.style.setProperty('--lightcolor', '#616161');
    // r.style.setProperty('--tabcolor', '#616161');
    // r.style.setProperty('--btndisabled', '#c9c9c9');
    // r.style.setProperty('--uploadtext', '#353f4a');
    // r.style.setProperty('--underlinetext', '#a4a4a4');
    // r.style.setProperty('--uploadsize', '#a4a4a4');
    // r.style.setProperty('--sitesep', '#efefef');
    // r.style.setProperty('--dropdownborder', 'rgba(0, 0, 0, 0.15)');
    // r.style.setProperty('--webkitshadow', 'rgba(0, 0, 0, 0.175)');
    // r.style.setProperty('--right_icon', 'url(./assets/right_arrow.svg)');
    // r.style.setProperty('--right_icon_hover', 'url(./assets/right_arrow_white.svg)');
    // r.style.setProperty('--filter_icon', 'url(./assets/filter_icon.svg)');
    // r.style.setProperty('--sort_icon', 'url(./assets/sort_icon.svg)');
    // r.style.setProperty('--tr_icon', 'url(./assets/img/Thomson-Reuters-logo.svg)');
    // r.style.setProperty('--close_icon', 'url(./assets/close_black_icon.svg)');
    // r.style.setProperty('--lock_icon', 'url(./assets/ic_lock.svg)');
    // r.style.setProperty('--lock_icon_hover', 'url(./assets/ic_lock-white.svg)');
    // r.style.setProperty('--site_icon', 'url(./assets/site_icon.svg)');
    // r.style.setProperty('--site_icon_hover', 'url(./assets/site_icon_white.svg)');
    // r.style.setProperty('--upload_done_icon', 'url(./assets/success2.svg)');
    // r.style.setProperty('--upload_icon', 'url(./assets/ic_upload_final.svg)');
    // r.style.setProperty('--menubg', 'rgb(255, 255, 255)');
    // r.style.setProperty('--selectpanelborder', 'rgb(255, 255, 255)');
    // r.style.setProperty('--menubghover', 'rgb(201, 201, 201)');
    // r.style.setProperty('--matborder', 'rgba(0,0,0,.12)');
    // r.style.setProperty('--placeholder', 'rgb(156, 154, 154)');
    // r.style.setProperty('--radioBtnClr', 'gray');
    // r.style.setProperty('--matoptionSelected', 'var(--accent)');
    // r.style.setProperty('--menuselected', 'var(--accent)');
    // r.style.setProperty('--menuhovertxtselected', 'var(--accent)');
    // r.style.setProperty('--menutxt', 'var(--black)');
    // r.style.setProperty('--tabhighlighter', 'var(--accent)');
    // r.style.setProperty('--btndisabledbgcolor', 'rgba(224, 224, 224, 0.712)');
    // r.style.setProperty('--darkgray2', '#333333');
    // r.style.setProperty('--container', 'rgb(245, 245, 245)');
    // r.style.setProperty('--filehover', '#6264a73b');
    // r.style.setProperty('--accentdark', '#8183b9');
    // r.style.setProperty('--texthover', 'white');
    // r.style.setProperty('--radioBtnHover', 'white');
    // r.style.setProperty('--radioBtnChecked', '#6264a7');
    // r.style.setProperty('--accentBtn', '#6264a7');
    // r.style.setProperty('--accentBtnTxt', 'white');
    // r.style.setProperty('--inputhover', 'var(--accent)');
    // r.style.setProperty('--breadcrumbText', 'var(--uploadtext)');
    // r.style.setProperty('--checkboxchecked', '#6264a7');
    // r.style.setProperty('--checkboxround', '#fff');
    // r.style.setProperty('--checkboxcheckedhover', 'var(--accentlight)');
    // r.style.setProperty('--selectarrow', 'var(--uploadtext)');
    // r.style.setProperty('--cardborder', 'var(--themebg2)');
    // r.style.setProperty('--matselectedbg', 'rgba(0,0,0,.12)');
    // r.style.setProperty('--matselecthovertxt', 'var(--uploadtext)');
    // r.style.setProperty('--matmenuhovertxt', 'var(--accent)');
    // r.style.setProperty('--matselecthoverbg', 'rgb(0,0,0,0.035)');
    // r.style.setProperty('--menuselectedtxt', '#fff');
    // r.style.setProperty('--progressbar', 'var(-accent)');
    // r.style.setProperty('--progressbar_buffer', '#c5cae9');
    // r.style.setProperty('--link', 'var(--accent)');
    // r.style.setProperty('--mildgray', '#38424c');
    // r.style.setProperty('--uploadborder', 'var(--container)');
    // r.style.setProperty('--uploadborderinit', 'var(--container)');

  }

  setDarkTheme() {
    document.body.className = '';
    document.body.className = 'darrktheme';
    // var r: HTMLElement = document.querySelector(':root');
    // r.style.setProperty('--themebg', 'rgb(45,44,44)');
    // r.style.setProperty('--themebg2', 'var(--themebg)');
    // r.style.setProperty('--black', 'var(--white)');
    // r.style.setProperty('--gray', '#c9c9c9');
    // r.style.setProperty('--lightcolor', '#c9c9c9');
    // r.style.setProperty('--tabcolor', '#ffffff');
    // r.style.setProperty('--btndisabled', '#808080');
    // r.style.setProperty('--uploadtext', 'var(--white)');
    // r.style.setProperty('--underlinetext', 'var(--white)');
    // r.style.setProperty('--uploadsize', 'var(--gray)');
    // r.style.setProperty('--sitesep', 'var(--white)');
    // r.style.setProperty('--dropdownborder', 'var(--white)');
    // r.style.setProperty('--webkitshadow', 'var(--white)');
    // r.style.setProperty('--right_icon', 'url(./assets/right_arrow_white.svg)');
    // r.style.setProperty('--right_icon_hover', 'url(./assets/right_arrow_white.svg)');
    // r.style.setProperty('--filter_icon', 'url(./assets/filter_icon_white.svg)');
    // r.style.setProperty('--sort_icon', 'url(./assets/sort_icon_white.svg)');
    // r.style.setProperty('--tr_icon', 'url(./assets/img/tr_logo_white.svg)');
    // r.style.setProperty('--close_icon', 'url(./assets/close_black_icon_white.svg)');
    // r.style.setProperty('--lock_icon', 'url(./assets/ic_lock.svg)');
    // r.style.setProperty('--lock_icon_hover', 'url(./assets/ic_lock-white.svg)');
    // r.style.setProperty('--site_icon', 'url(./assets/site_icon.svg)');
    // r.style.setProperty('--site_icon_hover', 'url(./assets/site_icon_white.svg)');
    // r.style.setProperty('--upload_done_icon', 'url(./assets/success2.svg)');
    // r.style.setProperty('--upload_icon', 'url(./assets/ic_upload_final_white.svg)');
    // r.style.setProperty('--menubg', 'rgb(75, 75, 75)');
    // r.style.setProperty('--selectpanelborder', 'rgb(75, 75, 75)');
    // r.style.setProperty('--menubghover', 'rgb(129, 127, 127)');
    // r.style.setProperty('--matborder', 'var(--gray)');
    // r.style.setProperty('--placeholder', '#c9c9c9;');
    // r.style.setProperty('--radioBtnClr', 'white');
    // r.style.setProperty('--matoptionSelected', 'white');
    // r.style.setProperty('--menuselected', 'var(--menubghover)');
    // r.style.setProperty('--menuhovertxtselected', 'var(--white)');
    // r.style.setProperty('--menutxt', 'var(--lightgray)');
    // r.style.setProperty('--tabhighlighter', 'var(--white)');
    // r.style.setProperty('--btndisabledbgcolor', 'rgb(61, 61, 61)');
    // r.style.setProperty('--darkgray2', 'var(--white)');
    // // r.style.setProperty('--container', 'rgb(202, 202, 202)');
    // r.style.setProperty('--container', 'rgb(75, 75, 75)');
    // r.style.setProperty('--filehover', 'rgb(0,0,0)');
    // r.style.setProperty('--accentdark', '#8183b9');
    // r.style.setProperty('--texthover', 'white');
    // r.style.setProperty('--radioBtnHover', 'white');
    // r.style.setProperty('--radioBtnChecked', '#6264a7');
    // r.style.setProperty('--accentBtn', '#6264a7');
    // r.style.setProperty('--accentBtnTxt', 'white');
    // r.style.setProperty('--inputhover', 'var(--white)');
    // r.style.setProperty('--breadcrumbText', 'var(--white)');
    // r.style.setProperty('--checkboxchecked', '#6264a7');
    // r.style.setProperty('--checkboxround', '#fff');
    // r.style.setProperty('--checkboxcheckedhover', 'var(--accentlight)');
    // r.style.setProperty('--selectarrow', 'var(--white)');
    // r.style.setProperty('--cardborder', 'var(--themebg2)');
    // r.style.setProperty('--matselectedbg', 'rgba(0,0,0,0.2)');
    // r.style.setProperty('--matselecthovertxt', 'white');
    // r.style.setProperty('--matmenuhovertxt', 'white');
    // r.style.setProperty('--matselecthoverbg', 'rgb(0,0,0,0.096)');
    // r.style.setProperty('--menuselectedtxt', '#fff');
    // r.style.setProperty('--progressbar', 'var(-accent)');
    // r.style.setProperty('--progressbar_buffer', '#c5cae9');
    // r.style.setProperty('--link', 'var(--accentlight)');
    // r.style.setProperty('--mildgray', 'white');
    // r.style.setProperty('--uploadborder', 'var(--container)');
    // r.style.setProperty('--uploadborderinit', 'var(--container)');

  }

  setHighlightedTheme() {
    document.body.className = '';
    document.body.className = 'contrasttheme';
    // var r: HTMLElement = document.querySelector(':root');
    // r.style.setProperty('--themebg', 'rgb(0,0,0)');
    // r.style.setProperty('--themebg', 'rgb(0,0,0)');
    // r.style.setProperty('--themebg2', 'var(--themebg)');
    // r.style.setProperty('--black', 'var(--white)');
    // r.style.setProperty('--gray', 'yellow');
    // r.style.setProperty('--lightcolor', 'yellow');
    // r.style.setProperty('--tabcolor', 'var(--white)');
    // r.style.setProperty('--btndisabled', 'black');
    // r.style.setProperty('--uploadtext', 'var(--white)');
    // r.style.setProperty('--underlinetext', 'yellow');
    // r.style.setProperty('--uploadsize', 'var(--gray)');
    // r.style.setProperty('--sitesep', 'var(--white)');
    // r.style.setProperty('--dropdownborder', 'var(--white)');
    // r.style.setProperty('--webkitshadow', 'var(--white)');
    // r.style.setProperty('--right_icon', 'url(./assets/right_arrow_yellow.svg)');
    // r.style.setProperty('--right_icon_hover', 'url(./assets/right_arrow.svg)');
    // r.style.setProperty('--filter_icon', 'url(./assets/filter_icon_yellow.svg)');
    // r.style.setProperty('--sort_icon', 'url(./assets/sort_icon_yellow.svg)');
    // r.style.setProperty('--tr_icon', 'url(./assets/img/tr_logo_white.svg)');
    // r.style.setProperty('--close_icon', 'url(./assets/close_black_icon_yellow.svg)');
    // r.style.setProperty('--lock_icon', 'url(./assets/ic_lock-yellow.svg)');
    // r.style.setProperty('--lock_icon_hover', 'url(./assets/ic_lock-black.svg)');
    // r.style.setProperty('--site_icon', 'url(./assets/site_icon_yellow.svg)');
    // r.style.setProperty('--site_icon_hover', 'url(./assets/site_icon_black.svg)');
    // r.style.setProperty('--upload_done_icon', 'url(./assets/upload_done_yellow.svg)');
    // r.style.setProperty('--upload_icon', 'url(./assets/ic_upload_final_yellow.svg)');
    // r.style.setProperty('--menubg', 'rgb(0,0,0)');
    // r.style.setProperty('--menubghover', 'rgb(129, 127, 127)');
    // r.style.setProperty('--matborder', 'white');
    // r.style.setProperty('--placeholder', '#c9c9c9;');
    // r.style.setProperty('--radioBtnClr', 'white');
    // r.style.setProperty('--matoptionSelected', 'black');
    // r.style.setProperty('--menuselected', 'rgb(26,235,235)');
    // r.style.setProperty('--menuhovertxtselected', 'var(--white)');
    // r.style.setProperty('--menutxt', '#fff');
    // r.style.setProperty('--tabhighlighter', 'rgb(26,235,235)');
    // r.style.setProperty('--btndisabledbgcolor', 'rgb(63, 253, 63)');
    // r.style.setProperty('--darkgray2', 'var(--white)');
    // //r.style.setProperty('--container', 'rgb(202, 202, 202)');
    // r.style.setProperty('--container', 'rgb(0, 0, 0)');
    // r.style.setProperty('--filehover', 'rgb(0, 0, 0)');
    // r.style.setProperty('--accentdark', 'yellow');
    // r.style.setProperty('--texthover', 'black');
    // r.style.setProperty('--radioBtnHover', 'black');
    // r.style.setProperty('--radioBtnChecked', 'white');
    // r.style.setProperty('--accentBtn', 'white');
    // r.style.setProperty('--accentBtnTxt', 'black');
    // r.style.setProperty('--inputhover', '#ff1');
    // r.style.setProperty('--breadcrumbText', '#ff1');
    // r.style.setProperty('--checkboxchecked', 'rgb(26,235,235)');
    // r.style.setProperty('--checkboxround', '#000');
    // r.style.setProperty('--checkboxcheckedhover', 'rgb(26,235,235)');
    // r.style.setProperty('--selectarrow', '#ff1');
    // r.style.setProperty('--cardborder', '#fff');
    // r.style.setProperty('--matselectedbg', 'rgb(26,235,235)');
    // r.style.setProperty('--matselecthovertxt', 'black');
    // r.style.setProperty('--matmenuhovertxt', 'black');
    // r.style.setProperty('--matselecthoverbg', '#ff1');
    // r.style.setProperty('--menuselectedtxt', '#000');
    // r.style.setProperty('--selectpanelborder', '#fff');
    // r.style.setProperty('--progressbar', 'rgb(146,195,83)');
    // r.style.setProperty('--progressbar_buffer', 'rgb(45,44,44)');
    // r.style.setProperty('--link', 'white');
    // r.style.setProperty('--mildgray', 'white');
    // r.style.setProperty('--uploadborder', '#ff1');
    // r.style.setProperty('--uploadborderinit', '#fff');

  }
}


